import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/gradeActions";
import { Actions as ALLOWANCEACTIONS } from "../../store/actions/allowanceActions";
import _ from "lodash";
import GradeRow from "./GradeRow";
import { PlusIcon } from "@heroicons/react/20/solid";
import LoadingContent from "../common/LoadingContent";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import NoItemsRow from "../common/NoItemsRow";
import UpgradeRequired from "../company-pages/UpgradeRequired";
import { useState } from "react";
import { useMemo } from "react";
import HeaderSort from "@/common/tables/HeaderSort";

const Grades = ({
	gradesGetList,
	gradeList,
	gradeSetOpenModal,
	allowanceGetList,
	userPermissions,
	includedInPlan,
	org,
	isDemo,
}) => {
	useEffect(() => {
		if (gradeList) return;
		gradesGetList();
		allowanceGetList();
	}, [org]);

	const [sortType, setSortType] = useState("asc");
	const [sortBy, setSortBy] = useState("name");

	const sortedGrades = useMemo(() => {
		return _.orderBy(gradeList, [sortBy], [sortType]);
	}, [gradeList, sortBy, sortType]);

	if (!includedInPlan && !isDemo) return <UpgradeRequired />;
	if (userPermissions == "None") return <InvalidPermissions />;
	if (!gradeList) return <LoadingContent />;

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Grades</h1>
						</div>
						{userPermissions != "Read" && (
							<div className="col-sm-4 pull-right">
								<div
									className="btn btn-success pull-right"
									onClick={() => gradeSetOpenModal(true, null)}
								>
									<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									<div style={{ float: "left" }}>Add New Grade</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="content">
				<div
					className="table-responsive"
					style={{ overflow: "auto" }}
				>
					<div
						id="active-people-table_wrapper"
						className="dataTables_wrapper no-footer"
					>
						<table
							id="active-people-table"
							className="js-table-sections table table-hover"
						>
							<thead style={{ display: "table-header-group" }}>
								<tr>
									<th width="5%"></th>
									<HeaderSort
										{...{
											code: "name",
											sortBy,
											setSortBy,
											sortType,
											setSortType,
										}}
									>
										Name
									</HeaderSort>
									<th>Salary</th>
									<HeaderSort
										{...{
											code: "updatedAt",
											sortBy,
											setSortBy,
											sortType,
											setSortType,
										}}
									>
										Last Updated
									</HeaderSort>
								</tr>
							</thead>
							<tbody>
								{sortedGrades?.length > 0 ? (
									sortedGrades?.map((grade) => (
										<GradeRow
											key={grade.id}
											grade={grade}
										/>
									))
								) : (
                  <tr>
										<NoItemsRow name="Grades" as="td" colSpan={4} />
                  </tr>
								)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const userPermissions = state?.permissions?.my?.permissions?.grades;

	return {
		...state.grades,
		userPermissions,
		org: state?.company?.settings?.org,
		isDemo: state?.company?.settings?.isDemo,
		includedInPlan: state.permissions?.plan?.grades,
	};
};

const mapDispatchToProps = (dispatch) => ({
	allowanceGetList: () => dispatch(ALLOWANCEACTIONS.allowanceGetList()),
	gradesGetList: () => dispatch(ACTIONS.gradesGetList()),
	gradeSetOpenModal: (status, grade) => dispatch(ACTIONS.gradeSetOpenModal(status, grade)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Grades);
